const desktop = theme => {
  const {toVW} = theme;
  return {};
};

const mobile = theme => {
  const {toVW} = theme;
  const iconWidth = 35;
  const iconRatio = 0.875;

  return {
    title: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '8px',
      '& h5': {
        margin: 0,
        color: theme.textColor,
        fontSize: '14px',
      },
    },
    container: {
      padding: '20px',
      paddingTop: 0,
      display: 'flex',
      flexDirection: 'column',
      height: '78dvh',
      justifyContent: 'space-between',
    },
    header: {
      textAlign: 'center',
      marginBottom: '24px',
      '& h1': {
        margin: 0,
        fontSize: '24px',
        color: theme.textColor,
      },
    },
    resultItem: {
      display: 'flex',
      alignItems: 'center',
      padding: '16px',
      paddingTop: 0,
      borderRadius: '12px',
      backgroundColor: theme.modalBackground,
      gap: '16px',
      flexDirection: 'column',
    },
    currentPlayer: {
      border: `2px solid ${theme.primaryColor}`,
    },
    rankContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
    },
    rank: {
      fontSize: '105px',
      fontWeight: 'bold',
      color: theme.textColor,
    },
    rankSuffix: {
      fontSize: '50px',
      color: theme.textColor,
    },
    rankContent: {
      position: 'absolute',
    },
    prizeContainer: {
      marginTop: '10px',
      display: 'flex',
      flexDirection: 'column',
      rowGap: '10px',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
    },
    prizeMessageSmall: {
      fontSize: '14px',
      color: theme.textColor,
      fontWeight: '700',
    },
    prizeMessage: {
      fontSize: '24px',
      color: theme.textColor,
      fontWeight: '700',
    },
    prizeAmount: {
      ...theme.goldGradientTextStyles,
      fontSize: '24px',
      fontWeight: 'bold',
    },
    bottomSection: {
      display: 'flex',
      flexDirection: 'row',
      columnGap: '10px',
    },
    closeButton: {},
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
